// extracted by mini-css-extract-plugin
export var circle = "_fp-1";
export var exitConfirmationModal = "_fp-5";
export var iframe = "_fp-0";
export var offline = "_fp-3";
export var online = "_fp-2";
export var workstationSelectError = "_fp-4";